import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'components'
import { SettingsModule } from 'modules'

import { FaUserAlt, FaEllipsisV } from 'react-icons/fa'

const Container = styled.div`
    display: grid;
    grid-template-columns: 2rem 1fr;
    grid-template-rows: auto;
    column-gap: 0.5rem;
    background-color: var(--secondary-color);
    padding: 1rem;
    border-radius: 0 5px 0 0;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid var(--primary-accent-color);
`

const Image = styled.img`
    width: 2rem;
    height: 2rem;
    object-fit: cover; 
    border-radius: 50%;
    border: 1px solid var(--secondary-color);
    /* grid-row: 1/ span 2;
    grid-column: 1/ span 1; */
    align-self: center;
    justify-self: center;
`

const ImagePlaceholder = styled.div`
    width: 2rem;
    height: 2rem;
    object-fit: cover; 
    border-radius: 50%;
    border: 1px solid var(--secondary-color);
    /* grid-row: 1/ span 2;
    grid-column: 1/ span 1; */
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--secondary-color);
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* grid-row: 1/ span 2; */
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1rem;
    align-self: end;
    max-width: 9rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    align-self: flex-start;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    align-self: start;
    max-width: 10rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

`

const ProfileSection = props => {
    const {
        img,
        name,
        email,
        onSelect
    } = props;
    const dispatch = useDispatch()
    const buttonStyle = {
        margin: 0,
        backgroundColor: 'var(--primary-accent-color)',
        padding: '0.2rem',
        // fontSize: '0.9rem'
        // width: '1rem',
        // height: '1rem'
    }
    const openSettings = () => {
        dispatch({
            type: 'SET_MODAL',
            element: <SettingsModule/>,
            id: 'SettingsModule'
        })
    }
    
    return (
        <Container onClick={onSelect}>
            {img ? <Image src={img}/> : <ImagePlaceholder><FaUserAlt/></ImagePlaceholder>}
            <TextContainer>
                <Title>{name}</Title>
                <Subtitle>{email}</Subtitle>
            </TextContainer>
        </Container>
    )
}

export default ProfileSection;